








































import { ButtonType } from '@getaccept/lib-ui';
import { SignatureConstants } from '@getaccept/lib-shared/src/signature/constants/signature.constants';
import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { SigningPageDocument } from '@getaccept/lib-shared/src/types/signing-page-document';
import type { PropType } from '@vue/composition-api';
import { watch, computed, ref, defineComponent } from '@vue/composition-api';
import { SigningHelper } from '../../helpers/signing.helper';
import SignConsent from './ESignConsent.vue';

export default defineComponent({
  components: {
    SignConsent,
  },
  props: {
    entity: {
      type: Object as PropType<Entity>,
      required: true,
    },
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    document: {
      type: Object as PropType<SigningPageDocument>,
      required: true,
    },
    signText: {
      type: String,
      default: '',
    },
    reviewPending: {
      type: Boolean,
      default: false,
    },
    hasInitials: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const initials = ref('');
    const initialsValidation = ref('');
    const showConsent = ref(false);

    const isSigningInitials = computed((): boolean => props.document.isSigningInitials === 1);

    const watchInitials = () => {
      initialsValidation.value = '';
    };
    watch(initials, watchInitials);

    const handleShowConsent = (): void => {
      showConsent.value = true;
    };

    const handleSignDocument = () => {
      if (props.reviewPending) {
        close();
        return;
      }

      if (!isSigningInitials.value || props.hasInitials) {
        emit('sign', '');
        return;
      }

      initialsValidation.value = SigningHelper.validateInitials(initials.value);
      if (!initialsValidation.value) {
        emit('sign', initials.value);
      }
    };

    const close = () => {
      emit('close');
    };

    return {
      ButtonType,
      initialsMaxLength: SignatureConstants.initialsMaxLength,
      initials,
      initialsValidation,
      showConsent,
      isSigningInitials,
      handleShowConsent,
      handleSignDocument,
      close,
    };
  },
});
